import React from 'react'
import { OutTable, ExcelRenderer } from "react-excel-renderer";
import axios from 'axios';


export default function DisplayExcel({ url }) {
    const [excelData, setExcelData] = React.useState(null)

    React.useEffect(() => {
        loadExcel()
        return () => {
            loadExcel()
        }
    }, []);

    const loadExcel = async () => {
        // Backend should provide URLs with single SAS tokens
        // If URL has multiple ? characters, log error but try to use first token only
        let cleanUrl = url
        if (url && url.includes('?')) {
          const questionMarkCount = (url.match(/\?/g) || []).length
          if (questionMarkCount > 1) {
            console.error('ERROR: URL has multiple query strings (double SAS token). Backend should fix this.')
            // Try to use only the first query string (first SAS token)
            const parts = url.split('?')
            cleanUrl = parts[0] + '?' + parts[1]
            console.warn('Using first SAS token only:', cleanUrl.substring(0, 100) + '...')
          }
        }
        console.log('Loading Excel from URL:', cleanUrl.substring(0, 100) + '...');
        axios.get(cleanUrl, { responseType: 'blob' }).then((response) => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            ExcelRenderer(blob, (err, resp) => {
                if (err) {
                    console.log(err);
                } else {
                    setExcelData({
                        cols: resp.cols,
                        rows: resp.rows
                    });
                }
            });
        });
    }
    return (
        <div style={{ height: '60vh', overflowY: 'overlay' }}>
            {excelData !== null && (
                <OutTable
                    data={excelData.rows}
                    columns={excelData.cols}
                    tableClassName="ExcelTable2007"
                    tableHeaderRowClass="heading"
                />)
            }
        </div>
    )
}